import type { components } from "@/api/schema";
import { type IntentName, statusIntent } from "@/design";

type PromotionStatus = components["schemas"]["Promotion"]["status"];

/**
 * The BE promotion enum is `draft | active | finish | archived`. The shared
 * design taxonomy (status-taxonomy.json, domain "promotion") only defines
 * `draft | active | finished`. We do NOT edit the shared design file from a
 * feature; instead we normalise BE codes onto the taxonomy here and supply
 * intents for codes the taxonomy doesn't carry (`archived`).
 */
export function promotionStatusIntent(status: PromotionStatus): IntentName {
  switch (status) {
    case "finish":
      return statusIntent("promotion", "finished");
    case "archived":
      return "neutral";
    default:
      return statusIntent("promotion", status);
  }
}
